import { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { useAuth } from '../lib/auth';

/**
 * Iter 236.m.16 (Carlos): contador de OCs pendientes de recepción.
 * Visible para roles que gestionan bodega + roles de compras.
 * Refresca cada 5 min y al volver foco a la pestaña.
 *
 * Devuelve { count, con_factura, sin_factura }
 */
export function useOCPendientesRecepcionCount() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ count: 0, con_factura: 0, sin_factura: 0 });

  const role = (user?.rol || user?.role || '').toLowerCase();
  const canSee = [
    'admin', 'administrador', 'gerencia',
    'bodega_admin', 'jefe_bodega', 'bodega',
    'compras', 'comprador', 'jefe_compras',
  ].includes(role);

  const fetchCount = useCallback(async () => {
    if (!user || !canSee) return;
    try {
      const res = await api.get('/bodega/oc-pendientes-recepcion/count');
      setStats({
        count: res.data?.count || 0,
        con_factura: res.data?.con_factura || 0,
        sin_factura: res.data?.sin_factura || 0,
      });
    } catch {
      setStats({ count: 0, con_factura: 0, sin_factura: 0 });
    }
  }, [user, canSee]);

  useEffect(() => {
    if (!user || !canSee) return;
    fetchCount();
    const interval = setInterval(fetchCount, 5 * 60 * 1000);
    const onFocus = () => fetchCount();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, [user, canSee, fetchCount]);

  return stats;
}
